<template>
  <div class="page page-settings content">
    <h1 class="page__title">{{ str('settings.menuTitle') }}</h1>
    <div class="notification-settings" v-if="showNotificationSettings">
      <p>{{ str('global.notifications') }}</p>
      <JsToggle
        :value="$store.getters.pushNotificationsEnabled"
        :height="30"
        @change="notificationsSettingChanged($event)"
      ></JsToggle>
    </div>
    <div v-if="$store.getters.hasProduction">
      <h3>Basisverkaufspreis</h3>
      <ProducerSettings />
    </div>
  </div>
</template>

<script>
  import ProducerSettings from '@/components/settings/ProducerSettings'
  import { ToggleButton as JsToggle } from 'vue-js-toggle-button'

  export default {
    name: 'page-settings',
    components: {
      ProducerSettings,
      JsToggle,
    },
    data() {
      return {
        enableNotifications: false,
        notificationSound: false,
      }
    },
    computed: {
      showNotificationSettings() {
        const swRegistration = this.$store.getters.serviceWorkerRegistration
        if (
          !swRegistration ||
          !('pushManager' in swRegistration) ||
          !('Notification' in window)
        ) {
          return false
        }
        return true
      },
    },
    methods: {
      notificationsSettingChanged: function (data) {
        if (data.value) {
          this.$store.dispatch('subscribeToPushApi')
          this.$store.dispatch('requestNotificationsPermission')
        } else {
          this.$store.dispatch('unsubscribeFromPushApi')
          this.$store.dispatch('disableNotifications')
        }
      },
    },
  }
</script>

<style lang="scss">
  .page-settings {
    max-width: $content-page-width;
  }

  .notification-settings {
    display: flex;
    justify-content: space-between;
    margin-bottom: spacer(2);
  }
</style>
